/* eslint-disable import/prefer-default-export */
export const apiKey =
	'1CLCEX8xAtjnEr5iDUheAVo2q3GhmNdYsxFBoNNUhDws1EgeCQA2cg4ioaPjxyZ9EsmyR8uFYDcOPOQh2NrOI7hZbzA4mwVUCV5OtFrkOyUoiMSZSOn83vqnxWtNg97G';
